import { h } from 'preact'
import { Message } from '../../../../lib/intl/Message'
import { InfoHeading } from './shared'
import { Geografi, isGeografi } from '../../../domain'
import { useAppState } from '../../../../lib/redux-provider-nohooks'
import { idFrom } from '../../../api'

type Props = {
  geografi: Geografi
}

export function BydelsvalgInfo({ geografi }: Props) {
  if (idFrom(geografi) === '0301') {
    return (
      <section>
        <InfoHeading id="info-bydelsvalg-tittel" />
        <Message id="info-bydelsvalg-beskrivelse" />
      </section>
    )
  }

  return null
}

export function ConnectedBydelsvalgInfo() {
  const { page } = useAppState()
  const currentPage = page.current

  if (!isGeografi(currentPage)) {
    return null
  }

  return <BydelsvalgInfo geografi={currentPage} />
}
